import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Profile from '../views/Profile.vue'
import RatingForm from '../views/Rating/MainForm.vue'

import CreatePassword from '../views/CreatePassword.vue'

import ContactUs from '../views/ContactUs.vue'
import ProfileAlert from '../views/ProfileAlert.vue'

import QuoteIndex from '../views/Quote/Index.vue'
import QuoteCreate from '../views/Quote/Create.vue'
import QuoteDetail from '../views/Quote/Detail.vue'
import QuoteMyDetail from '../views/Quote/MyDetail.vue'
import QuoteUpdate from '../views/Quote/Update.vue'

import MygroupIndex from '../views/mygroup/Index.vue'
import MygroupCreate from '../views/mygroup/Create.vue'
import MygroupUpdate from '../views/mygroup/Update.vue'

import ChangePw from '../views/Password/ChangePw.vue'
import ForgotPw from '../views/Password/ForgotPw.vue'
import ResetPw from '../views/Password/ResetPw.vue'

import UpdateCompanyProfile from '../views/CompanyProfile/Update.vue'

import Store from '../store'

const DefaultContainer = () => import('@/containers/DefaultContainer')

VueRouter.prototype.open = function (routeObject) {
  const { href } = this.resolve(routeObject)
  window.open(href, '_blank')
}

Vue.use(VueRouter)

const unAuth = (to, from, next) => {
  if (window.$cookies.isKey('token')) {
    next(
      { name: 'บริษัท' }
    )
  } else {
    next()
  }
}

const auth = (to, from, next) => {
  if (!window.$cookies.isKey('token')) {
    next(
      { name: 'เข้าสู่ระบบ' }
    )
  } else {
    next()
  }
}

const approved = (to, from, next) => {
  if (!window.$cookies.isKey('token')) {
    next(
      { name: 'เข้าสู่ระบบ' }
    )
  } else if (Store.state.userMeta.company.carrierStatus !== 1) {
    alert('บัญชีของท่านยังไม่ได้รับการยืนยันตัวตน กรุณาติดต่อเจ้าหน้าที่')
    next(
      { name: 'ติดต่อเรา' }
    )
  } else {
    next()
  }
}

const approvedProfile = (to, from, next) => {
  if (!window.$cookies.isKey('token')) {
    next(
      { name: 'เข้าสู่ระบบ' }
    )
  } else if (Store.state.userMeta.company.carrierStatus !== 1) {
    // to alert
    next(
      { name: 'แจ้งเตือนโปรไฟล์' }
    )
  } else {
    next()
  }
}

const routes = [
  {
    path: '/',
    redirect: '/company',
    component: DefaultContainer,
    children: [
      {
        path: 'company',
        name: 'บริษัท',
        redirect: '/company/index',
        component: {
          render (c) { return c('router-view') }
        },
        children: [
          {
            path: 'index',
            name: 'ค้นหาบริษัท',
            component: Home
          },
          {
            path: 'profile/:companyUrl',
            name: 'โปรไฟล์',
            redirect: 'profile/:companyUrl/',
            component: {
              render (c) { return c('router-view') }
            },
            children: [
              {
                path: '',
                name: 'ดูโปรไฟล์',
                component: Profile
              },
              {
                path: 'make-rating',
                name: 'สร้างรีวิว',
                beforeEnter: approved,
                component: RatingForm
              }
            ]
          }
        ]
      },
      {
        path: 'profile/update',
        name: 'แก้ไขข้อมูลบริษัท',
        beforeEnter: auth,
        component: UpdateCompanyProfile
      },
      {
        path: 'register',
        name: 'สมัครสมาชิก',
        beforeEnter: unAuth,
        component: Register
      },
      {
        path: 'create-password',
        name: 'ตั้งรหัสผ่าน',
        beforeEnter: unAuth,
        component: CreatePassword
      },
      {
        path: 'login',
        name: 'เข้าสู่ระบบ',
        beforeEnter: unAuth,
        component: Login
      },
      {
        path: 'change-password',
        name: 'เปลี่ยนรหัสผ่าน',
        beforeEnter: auth,
        component: ChangePw
      },
      {
        path: 'forgot-password',
        name: 'ลืมรหัสผ่าน',
        beforeEnter: unAuth,
        component: ForgotPw
      },
      {
        path: 'reset-password/:token',
        name: 'ตั้งรหัสผ่านใหม่',
        beforeEnter: unAuth,
        component: ResetPw
      },
      {
        path: 'contact-us',
        name: 'ติดต่อเรา',
        component: ContactUs
      },
      {
        path: 'profile-alert',
        name: 'แจ้งเตือนโปรไฟล์',
        component: ProfileAlert
      },
      {
        path: 'quote-request',
        name: 'ใบขอราคา',
        redirect: '/quote-request/index/all',
        component: {
          render (c) { return c('router-view') }
        },
        children: [
          {
            path: 'index/:tabName',
            name: 'ใบขอราคาทั้งหมด',
            beforeEnter: auth,
            component: QuoteIndex
          },
          {
            path: 'create',
            name: 'สร้างใบขอราคา',
            beforeEnter: approvedProfile,
            component: QuoteCreate
          },
          {
            path: 'job/:jobId',
            name: 'รายละเอียดใบขอราคา',
            beforeEnter: approvedProfile,
            component: QuoteDetail
          },
          {
            path: 'myjob/:jobId',
            name: 'รายละเอียดใบขอราคาของฉัน',
            beforeEnter: approvedProfile,
            component: QuoteMyDetail
          },
          {
            path: 'job/update/:jobId',
            name: 'แก้ไขใบขอราคา',
            beforeEnter: approvedProfile,
            component: QuoteUpdate
          }
        ]
      },
      {
        path: 'mygroup',
        name: 'กลุ่มของฉัน',
        redirect: '/mygroup/index',
        beforeEnter: approved,
        component: {
          render (c) { return c('router-view') }
        },
        children: [
          {
            path: 'index',
            name: 'กลุ่มทั้งหมด',
            component: MygroupIndex
          },
          {
            path: 'create',
            name: 'สร้างกลุ่มใหม่',
            component: MygroupCreate
          },
          {
            path: 'update/:groupId',
            name: 'แก้ไขกลุ่ม',
            component: MygroupUpdate
          }
        ]
      }
    ]
  }
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: 'open active'
})

export default router
